import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { routeMap } from '@/routes/routeMap';

type Payload = { remainingDebt: number };
type Props = ModalProps<Payload>;

const AgreementHasDebt = ({ payload }: Props) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('AgreementHasDebt.title')}>
      <p>{t('AgreementHasDebt.text', { amount: payload.remainingDebt })}</p>
      <ModalActions>
        <LinkButton to={routeMap.home}>{t('AgreementHasDebt.button')}</LinkButton>
      </ModalActions>
    </Modal>
  );
};

export default AgreementHasDebt;
